export const AUDIO_NOTE_PLAYED = 'Voice Note Played'; // params: groupId
export const AUDIO_NOTE_PAUSED = 'Voice Note Paused'; // params: groupId
